import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { StoreService } from '../store.service';
var ExerciseWorkComponent = (function () {
    function ExerciseWorkComponent(route, router, el, apiService, commonService, storeService) {
        this.route = route;
        this.router = router;
        this.el = el;
        this.apiService = apiService;
        this.commonService = commonService;
        this.storeService = storeService;
        this.openFlag = 1; //是否隐私提交
        this.isOpenClass = 0; //是否公开课
        this.allQuestionsNumber = 1; //题目数量
        this.currentNumber = 1; //当前完成题目数量
        this.theme = 'sight'; //主题
        this.canSave = false; //是否可以保存
        this.isSave = false;
        this.clickAble = true; //防止多次点击
        this.isShowTip = false; //是都显示提示框
        this.isCollapse = true; //是否收拢
        this.isShowToast = false; //是否显示toast
        this.tipType = ""; //提示框类型
        this.uploadId = ''; //查询上传文件条件
        this.uploadDisabled = false; //是否允许上传
        this.isShowPreview = false; //是否显示预览
        this.isShowLoading = false; //是否显示loading
        this.isPopupEnter = false;
        this.isWechat = false; //是否微信
        this.isShowPopup = false;
        this.assetsRoute = '../../assets';
        this.saveError = false;
        this.isShowFinishTip = false; //是否完成题目
        this.isSlideFinal = false; //题目是否做完
        this.isShowBackDesc = false; //是否展示背景描述
        this.isNextQuestion = false; //是否解锁下一题
        this.headTitle = "";
        this.blankSave = true; //空保存  false : 不是空保存 true:是空保存
        this.isNeedCorrect = true; //试卷是否需要批改 默认需要
        this.tempWorkStatus = 0; //临时作业状态，这里是用来判断当前作业状态如果大于等于20就不再次提交
        this.checkElse = false; //实战作业是否选择了其他这个选项
        this.onceValue = 0;
        this.terminalType = 0;
        this.showUrlText = "";
        this.campId = 0;
        this.isClick = 0; //是否第一次点击过lastday的pdf
    }
    ExerciseWorkComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.campId = Number(localStorage.getItem('campId'));
        this.isWechat = this.commonService.isWeiXin();
        $('#userIdContainer').val(localStorage.getItem('userId'));
        this.route.params.subscribe(function (params) {
            _this.lpmapcId = params['lpmapcId'];
            _this.learningPathMetaId = params['learningPathMetaId'];
        });
        this.route.queryParams.subscribe(function (params) {
            _this.isLastDay = !!params['isLastDay'];
            _this.isOnlyCamp = !!params['onlyCamp'];
            _this.isFirstDay = params['firstDay'];
            _this.projectId = params['projectId'];
            _this.courseLearningPathMetaId = params['courseLearningPathMetaId'];
        });
        if (this.isLastDay && JSON.parse(localStorage.getItem("exerciseGroup"))) {
            this.exerciseGroup = JSON.parse(localStorage.getItem("exerciseGroup"));
            this.terminalType = this.exerciseGroup.terminalType == 1 ? 1 : 2;
            this.exerciseType = this.exerciseGroup['type'];
            this.uploadList = localStorage.getItem("uploadList") && JSON.parse(localStorage.getItem("uploadList")) ? JSON.parse(localStorage.getItem("uploadList")) : [];
            this.pdfList = JSON.parse(localStorage.getItem("pdfList"));
            if (localStorage.getItem("uploadId")) {
                this.uploadId = localStorage.getItem("uploadId");
            }
            this.page = this.exerciseGroup.status == 0 || this.exerciseGroup.status == 10 ? 'list' : 'finish';
            this.currentNumber = 4;
            this.allQuestionsNumber = this.exerciseGroup['questionGroup'].length;
            this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
            this.blankSave = this.postData.some(function (item) { return item.selector && item.selector != null; }) ? false : true;
            this.buttonTxt = this.exerciseType === 3 && !this.isLastDay ? this.exerciseGroup.questionGroupMetaTitle : '一共' + this.allQuestionsNumber + '小题，立即作答';
            this.titleText();
            this.isNextQuestion = false;
            this.getOnceValue();
        }
        else {
            this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
                _this.exerciseGroup = result;
                _this.exerciseType = _this.exerciseGroup['type'];
                _this.isNeedCorrect = _this.exerciseGroup.needCorrect === 1;
                _this.page = result.status < 20 ? 'list' : 'finish';
                _this.allQuestionsNumber = _this.exerciseGroup['questionGroup'].length;
                _this.postData = _this.formatPostData(_this.exerciseGroup['questionGroup']);
                _this.blankSave = _this.postData.some(function (item) { return item.selector && item.selector != null; }) ? false : true;
                _this.buttonTxt = _this.exerciseType === 3 && !_this.isLastDay ? _this.exerciseGroup.questionGroupMetaTitle : '一共' + _this.allQuestionsNumber + '小题，立即作答';
                _this.titleText();
            }).then(function () {
                if (_this.isLastDay) {
                    var index = _this.commonService.getIndexByConditionIdInLists(_this.exerciseGroup['questionGroup'], 'type', 5);
                    _this.uploadId = _this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] ? _this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] : '';
                    _this.getExercisePdfAPI({
                        'campMetaId': Number(localStorage.getItem('campId')),
                        'optionsIds': _this.exerciseGroup['questionGroup'][0]['answers']
                    }).then(function (result) {
                        _this.pdfList = result;
                        _this.checkElse = result.length > 0 ? false : true;
                    });
                    _this.getUploadFileList({
                        'constituteId': _this.lpmapcId,
                        'questionId': _this.exerciseGroup['questionGroup'][index]['questionId'],
                        'campFileUploadIds': _this.uploadId
                    }).then(function (result) {
                        _this.uploadList = result['newFileList'];
                        _this.oldUploadList = result['oldFileList'];
                        _this.uploadDisabled = _this.uploadList.length === 10;
                        _this.terminalType = _this.isLastDay && _this.exerciseGroup.terminalType == 1 && _this.uploadList.length > 0 ? 1 : 2;
                    });
                    _this.getOnceValue();
                }
            });
        }
        localStorage.removeItem("moduleId");
    };
    ExerciseWorkComponent.prototype.ngAfterViewInit = function () {
        var self = this;
        this.commonService.initPage({
            'backgroundColor': 'rgba(40,51,130,1)'
        });
        $('body').css('height', 'auto');
        $('#wx-open-wrap').css('left', '-200%');
        window.addEventListener("popstate", function () {
            if (self.downloadUrl == document.referrer) {
                self.isLastDay = true;
                self.page = "answer";
                self.currentNumber = self.exerciseGroup['questionGroup'].length;
            }
        });
        // let wxBtn = document.body.querySelector(".wx-open-tag") as HTMLElement;
        // wxBtn.style.display = "block";
    };
    ExerciseWorkComponent.prototype.ngOnDestroy = function () {
        localStorage.removeItem("exerciseGroup");
        localStorage.removeItem("uploadList");
        localStorage.removeItem("pdfList");
        localStorage.removeItem("uploadId");
        localStorage.removeItem("canSave");
    };
    //获取lastDay的OnceValue
    ExerciseWorkComponent.prototype.getOnceValue = function () {
        var _this = this;
        this.onceValue = this.exerciseGroup ? this.commonService.getOnceValue(Number(this.exerciseGroup['questionGroup'][this.exerciseGroup['questionGroup'].length - 1].questionId), 11) : 0;
        this.showUrlText = window.location.hostname === 'm.transtalent.cn' ? "电脑端填写表单更方便哦。快点击“复制网址”，在电脑浏览器进行作答吧！<br><br>链接：https://m.transtalent.cn/pc/applytask" : "电脑端填写表单更方便哦。快点击“复制网址”，在电脑浏览器进行作答吧！<br><br>链接：https://m-uat.transtalent.cn/pc/applytask";
        this.commonService.getOnceIno(this.onceValue).then(function (result) {
            _this.isClick = result;
        });
    };
    //背景描述
    ExerciseWorkComponent.prototype.backgroundDesc = function () {
        this.isShowBackDesc = !this.isShowBackDesc;
    };
    ExerciseWorkComponent.prototype.titleText = function () {
        if (this.page === 'list') {
            if (this.isFirstDay || this.isLastDay) {
                this.headTitle = this.exerciseGroup.status === 0 ? "实战作业" : '';
            }
            else {
                this.headTitle = this.exerciseGroup.status === 0 ? "今日作业" : '';
            }
        }
        else if (this.page === 'answer') {
            this.headTitle = this.currentNumber + "/" + this.allQuestionsNumber;
        }
    };
    ExerciseWorkComponent.prototype.formatPostData = function (group) {
        var _this = this;
        var data = [];
        group.forEach(function (item) {
            if (item['type'] === 3 || item['type'] === 6 || item['type'] === 8) {
                data.push({
                    'constituteId': _this.lpmapcId,
                    'questionId': item['questionId'],
                    'tableData': item['tableData'],
                    'type': item['type']
                });
            }
            else {
                data.push({
                    'constituteId': _this.lpmapcId,
                    'questionId': item['questionId'],
                    'selector': item['answers'],
                    'type': item['type']
                });
            }
        });
        return data;
    };
    //获取练习册本体的高度
    ExerciseWorkComponent.prototype.setBodyHeight = function (event) {
        this.bodyHeight = event + 'rem';
    };
    //获取收拢展开
    ExerciseWorkComponent.prototype.getIsCollapse = function (event) {
        this.isCollapse = event;
    };
    /**
     * 进入答题页面
     * @param status:Number  进入答题页面状态（0：立即作答 1：编辑）
     */
    ExerciseWorkComponent.prototype.goAnswer = function (status) {
        var _this = this;
        this.clickAble = true;
        this.currentNumber = 1;
        if (this.isLastDay) {
            this.checkElse = this.exerciseGroup.questionGroup[0].answers == this.exerciseGroup['questionGroup'][0].options[this.exerciseGroup['questionGroup'][0].options.length - 1].optionId ? true : false;
        }
        var data = status === 0 ? { 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷立即作答', 'courseUnit': this.lpmapcId, 'type': 0 } : { 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷编辑', 'courseUnit': this.lpmapcId, 'type': 0 };
        this.commonService.learningPortEventLogByCandy(data).then(function () {
            _this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': _this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': _this.lpmapcId, 'type': 1 }).then();
        });
        this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
            _this.exerciseGroup = result;
            _this.terminalType = _this.isLastDay && _this.exerciseGroup.terminalType == 1 && _this.uploadList.length > 0 ? 1 : 2;
            _this.allQuestionsNumber = _this.exerciseGroup['questionGroup'].length;
            _this.postData = _this.formatPostData(_this.exerciseGroup['questionGroup']);
            _this.pageChangedInit('sight', 'answer', 'rgba(40,51,130,1)', 'linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
            _this.titleText();
            if (status == 1)
                _this.blankSave = false;
        });
        this.openNextQuestion();
        localStorage.setItem("uploadList", JSON.stringify(this.uploadList));
    };
    //是否解锁下一题
    ExerciseWorkComponent.prototype.openNextQuestion = function () {
        //判断是否可以解锁下一题
        if (this.postData[this.currentNumber - 1].type === 3 || this.postData[this.currentNumber - 1].type === 6 || this.postData[this.currentNumber - 1].type === 8) {
            //表格题
            var a_1 = [];
            this.postData[this.currentNumber - 1]['tableData'].forEach(function (item) {
                item.forEach(function (item3) {
                    a_1.push(item3);
                });
            });
            a_1.some(function (item) { return item !== ''; }) && a_1.length > 1 ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
        else if (this.postData[this.currentNumber - 1].type === 2 || this.postData[this.currentNumber - 1].type === 4) {
            //选择题
            this.postData[this.currentNumber - 1].selector ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
        else if (this.postData[this.currentNumber - 1].type === 1) {
            //文本题
            this.postData[this.currentNumber - 1].selector ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
        else if (this.postData[this.currentNumber - 1].type === 5) {
            //实战作业中的文本+图片题  有一个完成即可
            this.postData[this.currentNumber - 1].selector || this.uploadList.length > 0 ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
    };
    //保存
    ExerciseWorkComponent.prototype.saveAnswer = function (page) {
        var _this = this;
        if (!this.clickAble)
            return;
        this.canSave = false;
        this.clickAble = false;
        this.isSave = true;
        if (!this.blankSave) {
            this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷保存', 'courseUnit': this.lpmapcId, 'type': 0 }).then(function () {
                _this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': _this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': _this.lpmapcId, 'type': 2 }).then();
            });
            var index_1 = this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5);
            if (index_1 !== -1) {
                this.postData[index_1]['campFileUploadIds'] = this.uploadId;
            }
            // this.formatTableQAData(this.postData);
            var data = {};
            data['campMetaId'] = Number(localStorage.getItem('campId'));
            data['status'] = 10;
            data['openFlag'] = 1;
            if (this.isLastDay && this.campId != 2) {
                data['terminalType'] = 2;
                if (this.checkElse) {
                    if (this.postData[this.postData.length - 1]['campFileUploadIds']) {
                        this.postData[this.postData.length - 1]['campFileUploadIds'] = '';
                    }
                }
                else {
                    this.postData[this.postData.length - 1]['selector'] = '';
                }
            }
            data['campExerciseQuestionAnswersVOList'] = this.postData;
            this.exerciseCommitAPI(data, this.exerciseType).then(function (result) {
            }).catch(function (err) {
                if (err['error']['code'] === 101) {
                    _this.saveError = true;
                    _this.isShowToast = true;
                    _this.toastType = 2;
                    _this.errTxt = err['error']['msg'];
                    setTimeout(function () {
                        _this.saveError = false;
                        _this.clickAble = true;
                        _this.isShowToast = false;
                    }, 1500);
                }
            }).then(function () {
                if (!_this.saveError) {
                    return _this.getExerciseDetailAPI(_this.lpmapcId).then(function (result) {
                        return _this.exerciseGroup = result;
                    });
                }
            }).then(function () {
                if (!_this.saveError) {
                    _this.postData = _this.formatPostData(_this.exerciseGroup['questionGroup']);
                    _this.isShowTip = false;
                    _this.titleText();
                    if (_this.page === 'answer') {
                        _this.isShowToast = true;
                        _this.toastType = 3;
                        setTimeout(function () {
                            _this.isShowToast = false;
                        }, 1500);
                    }
                    _this.clickAble = true;
                    console.log("保存");
                    if (page == 'list') {
                        _this.goBack();
                    }
                    _this.openNextQuestion();
                    localStorage.removeItem("exerciseGroup");
                    localStorage.removeItem("uploadList");
                    localStorage.removeItem("pdfList");
                    localStorage.removeItem("uploadId");
                    localStorage.removeItem("canSave");
                    if (_this.isLastDay && _this.uploadId && !_this.checkElse) {
                        _this.getUploadFileList({
                            'constituteId': _this.lpmapcId,
                            'questionId': _this.exerciseGroup['questionGroup'][index_1]['questionId'],
                            'campFileUploadIds': _this.uploadId
                        }).then(function (result) {
                            _this.uploadList = result['newFileList'];
                            _this.oldUploadList = result['oldFileList'];
                            _this.uploadDisabled = _this.uploadList.length === 10;
                            localStorage.setItem("uploadList", JSON.stringify(_this.uploadList));
                        });
                    }
                }
            });
        }
    };
    //提示框继续
    ExerciseWorkComponent.prototype.tipsContinue = function () {
        var _this = this;
        console.log('智能作业临时状态', this.tempWorkStatus);
        console.log('智能作业数据postData', this.postData);
        console.log('智能作业数据this.exerciseGroup', this.exerciseGroup);
        if (this.tempWorkStatus >= 20) {
            console.log('该智能作业已提交过', this.exerciseGroup);
            return;
        }
        if (!this.clickAble)
            return;
        this.clickAble = false;
        this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷提交', 'courseUnit': this.lpmapcId, 'type': 0 }).then(function () {
            _this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': _this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': _this.lpmapcId, 'type': 2 }).then();
        });
        if (this.tipType === 'save') {
            this.clickAble = true;
            this.saveAnswer('list');
        }
        else if (this.tipType === 'finish') {
            // this.formatTableQAData(this.postData);
            var data_1 = {};
            data_1['campMetaId'] = Number(localStorage.getItem('campId'));
            data_1['status'] = 20;
            data_1['openFlag'] = this.openFlag;
            data_1['campExerciseQuestionAnswersVOList'] = this.postData;
            this.exerciseCommitAPI(data_1, this.exerciseType).then(function (result) {
                _this.tempWorkStatus = data_1['status'];
                _this.clickAble = true;
                _this.isShowTip = false;
                _this.isPopupEnter = false;
                _this.isShowBackDesc = false;
                _this.exerciseGroup.status = 20;
                localStorage.setItem("exerciseGroup", JSON.stringify(_this.exerciseGroup));
                _this.pageChangedInit('sight', 'finish', 'rgba(246,246,246,1)', 'linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
                setTimeout(function () {
                    _this.isShowPopup = false;
                    _this.commonService.initPage({ 'backgroundColor': 'rgba(246,246,246,1)' });
                }, 100);
            }).catch(function (err) {
                if (err['error']['code'] === 101) {
                    _this.saveError = true;
                    _this.isShowToast = true;
                    _this.toastType = 2;
                    _this.errTxt = err['error']['msg'];
                    setTimeout(function () {
                        _this.saveError = false;
                        _this.clickAble = true;
                        _this.isShowToast = false;
                    }, 1500);
                }
            }).then(function () {
                if (!_this.saveError) {
                    var learningPathMetaId = 0;
                    if (Number(localStorage.getItem("campId")) == 1) {
                        if (_this.isLastDay) {
                            learningPathMetaId = -49601;
                        }
                        else if (_this.isFirstDay) {
                            learningPathMetaId = -40401;
                        }
                    }
                    else if (Number(localStorage.getItem("campId")) == 2) {
                        if (_this.isLastDay) {
                            learningPathMetaId = -419601;
                        }
                        else if (_this.isFirstDay) {
                            learningPathMetaId = 414;
                        }
                    }
                    else if (Number(localStorage.getItem("campId")) == 3) {
                        if (_this.isLastDay) {
                            learningPathMetaId = -429601;
                        }
                        else if (_this.isFirstDay) {
                            learningPathMetaId = -42401;
                        }
                    }
                    if (_this.exerciseGroup.workSource == 'camp') {
                        _this.getCampDayProgress(Number(localStorage.getItem("campId")), _this.isLastDay || _this.isFirstDay ? learningPathMetaId : _this.learningPathMetaId).then(function (result) {
                            //确认提交答案的时候需要调用接口
                            if (result[0].finished == result[0].total) {
                                if (localStorage.getItem("projectId")) {
                                    _this.apiService.getProjectProgress(localStorage.getItem("projectId")).subscribe(function (res) {
                                        console.log("projectId", res);
                                    });
                                }
                                else {
                                    _this.apiService.getSingleProjectProgress().subscribe(function (res) {
                                        console.log(3333, res);
                                    });
                                }
                            }
                        });
                    }
                }
            });
        }
    };
    //判断表格题是否可以提交
    ExerciseWorkComponent.prototype.judgeTableCanCommit = function (arr) {
        var a = [];
        arr.forEach(function (item) {
            console.log(item);
            item['tableData'].forEach(function (item2) {
                item2.forEach(function (item3) {
                    a.push(item3);
                });
            });
        });
        return a.length > 0 && a.every(function (item) { return item !== ''; }) && arr.every(function (item) { return item.tableData.length > 0; }) ? a.filter(function (i) { return i === ''; }).length : 1;
    };
    ExerciseWorkComponent.prototype.slide = function (direction) {
        var _this = this;
        if (direction == "left") {
            //下一题
            this.currentNumber += 1;
            this.isNextQuestion = false;
            this.slideWrap(2);
            this.openNextQuestion();
            if (this.isLastDay) {
                localStorage.setItem("exerciseGroup", JSON.stringify(this.exerciseGroup));
                localStorage.setItem("pdfList", JSON.stringify(this.pdfList));
                this.uploadList = localStorage.getItem("uploadList") && JSON.parse(localStorage.getItem("uploadList")) ? JSON.parse(localStorage.getItem("uploadList")) : [];
            }
        }
        else {
            //上一题
            if (this.isLastDay && JSON.parse(localStorage.getItem("exerciseGroup"))) {
                this.isNextQuestion = true;
                // this.slideWrap(1);
                this.currentNumber -= 1;
            }
            else {
                this.isNextQuestion = true;
                this.slideWrap(1);
                this.currentNumber -= 1;
            }
        }
        this.titleText();
        setTimeout(function () {
            if (_this.exerciseGroup['questionGroup'][_this.currentNumber - 1].type === 1 || (_this.exerciseGroup['questionGroup'][_this.currentNumber - 1].type === 5 && _this.checkElse)) {
                $('#component-textarea-' + _this.exerciseGroup['questionGroup'][_this.currentNumber - 1].questionId + "-" + _this.currentNumber).height($('#component-textarea-' + _this.exerciseGroup['questionGroup'][_this.currentNumber - 1].questionId + "-" + _this.currentNumber)[0].scrollHeight);
            }
        });
    };
    //上下题目切换时显示当前题目所答内容
    ExerciseWorkComponent.prototype.slideWrap = function (i) {
        if (this.exerciseGroup['questionGroup'][this.currentNumber - i].type === 1) {
            //文本题
            this.exerciseGroup['questionGroup'][this.currentNumber - i].answers = this.postData[this.currentNumber - i].selector;
        }
        else if (this.exerciseGroup['questionGroup'][this.currentNumber - i].type === 2) {
            //单选题
            var str_1 = String(this.postData[this.currentNumber - i].selector);
            this.exerciseGroup['questionGroup'][this.currentNumber - i]['options'].forEach(function (item) {
                if (item.optionId == str_1) {
                    item.select = true;
                }
                else {
                    item.select = false;
                }
            });
        }
        else if (this.exerciseGroup['questionGroup'][this.currentNumber - i].type === 3 || this.exerciseGroup['questionGroup'][this.currentNumber - i].type === 6 || this.exerciseGroup['questionGroup'][this.currentNumber - i].type === 8) {
            //步骤题
            this.exerciseGroup['questionGroup'][this.currentNumber - i].tableData = this.postData[this.currentNumber - i].tableData;
        }
        else if (this.exerciseGroup['questionGroup'][this.currentNumber - i].type === 4) {
            //多选题
            this.exerciseGroup['questionGroup'][this.currentNumber - i].answers = this.postData[this.currentNumber - i].selector;
        }
    };
    //获取用户隐私选项
    ExerciseWorkComponent.prototype.getUserOpenFlag = function (event) {
        this.openFlag = event;
    };
    //完成练习题
    ExerciseWorkComponent.prototype.finishExercise = function (tabNum) {
        var learningPathId = null, courseId = null;
        this.route.queryParams.subscribe(function (queryParams) {
            learningPathId = queryParams['learningPathId'];
            courseId = queryParams['courseId'];
        });
        if (this.isLastDay) {
            //day7实战作业
            this.router.navigate(['learning-camp-response'], {
                queryParams: {
                    tabNum: tabNum,
                    constituteId: this.lpmapcId,
                    learningPathId: learningPathId,
                    courseId: courseId,
                    isLastDay: this.isLastDay,
                    onlyCamp: this.isOnlyCamp
                }
            }).then();
        }
        else if (this.isFirstDay) {
            this.router.navigate(['learning-camp-response'], {
                queryParams: {
                    tabNum: tabNum,
                    constituteId: this.lpmapcId,
                    learningPathId: learningPathId,
                    courseId: courseId,
                    firstDay: this.isFirstDay,
                    onlyCamp: this.isOnlyCamp
                }
            }).then();
        }
        else {
            if (learningPathId && courseId) {
                this.router.navigate(['learning-camp-response'], {
                    queryParams: {
                        tabNum: tabNum,
                        constituteId: this.lpmapcId,
                        learningPathId: learningPathId,
                        courseId: courseId
                    }
                }).then();
            }
            else {
                if (this.exerciseGroup.workSource == 'homework') {
                    if (this.projectId) {
                        this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: tabNum, constituteId: this.lpmapcId, projectId: this.projectId } }).then();
                    }
                    else if (this.courseLearningPathMetaId) {
                        this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: tabNum, constituteId: this.lpmapcId, courseLearningPathMetaId: this.courseLearningPathMetaId } }).then();
                    }
                }
                else {
                    this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: tabNum, constituteId: this.lpmapcId } }).then();
                }
            }
        }
    };
    //提交答案
    ExerciseWorkComponent.prototype.commitAnswer = function (status) {
        var that = this;
        if (status === 1) {
            that.postData = that.formatPostData(that.exerciseGroup['questionGroup']);
            console.log('确认提交前的数据', that.postData);
        }
        var tableQAList = that.postData.filter(function (item) { return (item['type'] === 3 || item['type'] === 6 || item['type'] === 8) && item['selector'] !== null; });
        if (!this.isLastDay && that.postData.filter(function (item) { return item['selector'] === null || item['selector'] === ''; }).length !== 0) {
            that.isShowToast = true;
            that.toastType = 0;
        }
        else if (this.isLastDay && this.campId == 2 && that.postData.filter(function (item) { return item.type !== 5 && (function (item) { return item['selector'] === null || item['selector'] === ''; }); }).length !== 0 && ((that.postData[that.postData.length - 1].selector === null || that.postData[that.postData.length - 1].selector === '') && this.uploadId == '')) {
            that.isShowToast = true;
            that.toastType = 0;
        }
        else if (this.isLastDay && this.campId != 2 && ((that.postData.filter(function (item) { return item.type !== 5 && item['selector'] === null; }).length !== 0 || ((that.postData[that.postData.length - 1].selector === null || that.postData[that.postData.length - 1].selector === '') && this.uploadId === '')) || this.checkElse && that.postData[that.postData.length - 1].selector === '' || !this.checkElse && this.uploadId === '')) {
            that.isShowToast = true;
            that.toastType = 0;
        }
        else if (tableQAList.length > 0 && that.judgeTableCanCommit(tableQAList) > 0) {
            that.isShowToast = true;
            that.toastType = 1;
        }
        else {
            that.tipType = 'finish';
            that.isShowPopup = true;
            setTimeout(function () {
                that.isPopupEnter = true;
            }, 300);
            //提交前先保存一下 防止图片pdf丢失
            if (this.isLastDay && !this.checkElse) {
                if (!that.clickAble)
                    return;
                that.clickAble = false;
                this.postData[this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5)]['campFileUploadIds'] = this.uploadId;
                var data = {};
                data['campMetaId'] = Number(localStorage.getItem('campId'));
                data['status'] = 10;
                data['openFlag'] = 1;
                data['campExerciseQuestionAnswersVOList'] = this.postData;
                if (this.isLastDay) {
                    data['terminalType'] = 2;
                }
                this.exerciseCommitAPI(data, this.exerciseType).then(function (result) {
                    that.clickAble = true;
                });
            }
        }
        setTimeout(function () {
            that.isShowToast = false;
        }, 2000);
        if (that.isWechat && that.isShowPopup) {
            try {
                $('#wx-open-wrap').css('left', '5%');
                var btn = document.getElementById('subscribe-btn');
                btn.addEventListener('success', function (e) {
                    $('#wx-open-wrap').css('left', '-200%');
                    that.isPopupEnter = false;
                    that.isShowPopup = false;
                    that.tipsContinue();
                });
                btn.addEventListener('error', function (e) {
                    $('#wx-open-wrap').css('left', '-200%');
                    that.isPopupEnter = false;
                    that.isShowPopup = false;
                    that.tipsContinue();
                });
            }
            catch (e) {
                console.log('error', e.message);
                $('#wx-open-wrap').css('left', '-200%');
                that.isPopupEnter = false;
                that.isShowPopup = false;
                that.tipsContinue();
            }
        }
    };
    //是否可以保存（不能保存不出现弹窗提示，可以保存出现弹窗提示）
    ExerciseWorkComponent.prototype.getCanSave = function (event) {
        this.canSave = event;
        localStorage.setItem("canSave", JSON.stringify(this.canSave));
    };
    //获取子组件提交的练习答案
    ExerciseWorkComponent.prototype.getPostData = function (event) {
        var _this = this;
        console.log("event", event);
        this.blankSave = false;
        if (event.wordOverrun) {
            this.isShowToast = true;
            this.toastType = 5;
            setTimeout(function () {
                _this.isShowToast = false;
            }, 2000);
        }
        //判断是否可以解锁下一题
        if (event.type === 3 || event.type === 6 || event.type === 8) {
            //表格题
            var a_2 = [];
            event['tableData'].forEach(function (item) {
                item.forEach(function (item3) {
                    a_2.push(item3);
                });
            });
            a_2.some(function (item) { return item !== ''; }) || event['tableData'].length > 1 ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
        else if (event.type === 2 || event.type === 4) {
            //选择题
            event.selector ? this.isNextQuestion = true : this.isNextQuestion = false;
            if (event.type === 4 && !this.isLastDay && !this.isFirstDay) {
                this.isNextQuestion = false;
            }
            if (event.type === 2 && this.isLastDay && this.exerciseGroup['questionGroup'][0].options[this.exerciseGroup['questionGroup'][0].options.length - 1].optionId == event['selector']) {
                this.checkElse = true;
            }
            else {
                this.checkElse = false;
            }
        }
        else if (event.type === 1) {
            //文本题
            event.selector ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
        else if (event.type === 5) {
            //实战作业中的文本+图片题
            event.selector || this.uploadList.length > 0 ? this.isNextQuestion = true : this.isNextQuestion = false;
        }
        if (JSON.parse(localStorage.getItem("exerciseGroup")) && event.type === 5 && event.selector !== '') {
            this.exerciseGroup['questionGroup'][this.currentNumber - 1].answers = event.selector;
            localStorage.setItem("exerciseGroup", JSON.stringify(this.exerciseGroup));
        }
        if (this.postData.length > 0) {
            if (this.postData.filter(function (item) { return item.questionId === event.questionId; }).length !== 0) {
                var index = this.postData.findIndex(function (v) { return v['questionId'] === event['questionId']; });
                if (!event['selector']) {
                    this.postData[index] = event;
                }
                else {
                    if (index !== -1) {
                        this.postData[index] = event;
                    }
                }
                if (event.type != 2) {
                    this.exerciseGroup['questionGroup'][this.currentNumber - 1].answers = event.selector;
                }
                else {
                    this.exerciseGroup['questionGroup'][this.currentNumber - 1].options.map(function (item) {
                        if (item.optionId == event.selector) {
                            item.select = true;
                        }
                    });
                }
            }
            else {
                this.postData.push(event);
            }
        }
        else {
            this.postData.push(event);
        }
        console.log(this.postData, "postData");
        if (this.postData.filter(function (item) { return item['type'] === 2 || item['type'] === 4; }).length > 0 && this.isLastDay) {
            var index = this.postData.findIndex(function (v) { return v['type'] === 2 || v['type'] === 4; });
            this.getExercisePdfAPI({
                'campMetaId': Number(localStorage.getItem('campId')),
                'optionsIds': this.postData[index]['selector']
            }).then(function (result) {
                _this.pdfList = result;
                console.log(_this.pdfList);
            });
        }
    };
    //提示框退出
    ExerciseWorkComponent.prototype.closeComponentTip = function () {
        var _this = this;
        this.openFlag = 1;
        var index = this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5);
        this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
            _this.exerciseGroup = result;
            _this.isShowTip = false;
        }).then(function () {
            _this.postData = _this.formatPostData(_this.exerciseGroup['questionGroup']);
            _this.goBack();
            localStorage.removeItem("exerciseGroup");
            localStorage.removeItem("uploadList");
            localStorage.removeItem("pdfList");
            localStorage.removeItem("uploadId");
            localStorage.removeItem("canSave");
            if (_this.isLastDay) {
                _this.getUploadFileList({
                    'constituteId': _this.lpmapcId,
                    'questionId': _this.exerciseGroup['questionGroup'][index]['questionId'],
                    'campFileUploadIds': _this.uploadId
                }).then(function (result) {
                    _this.uploadList = result['newFileList'];
                    console.log(_this.uploadList);
                    _this.oldUploadList = result['oldFileList'];
                    _this.uploadDisabled = _this.uploadList.length === 10;
                });
            }
        });
    };
    //页面切换时初始化背景
    ExerciseWorkComponent.prototype.pageChangedInit = function (theme, page, initColor, backgroundImage) {
        this.theme = theme;
        this.page = page;
        this.commonService.initPage({
            'backgroundColor': initColor,
            'backgroundImage': backgroundImage
        });
    };
    //返回
    ExerciseWorkComponent.prototype.exit = function () {
        var _this = this;
        this.isShowBackDesc = false;
        var learningPathId = null;
        var courseId = null;
        this.route.queryParams.subscribe(function (queryParams) {
            learningPathId = queryParams['learningPathId'];
            courseId = queryParams['courseId'];
        });
        if (JSON.parse(localStorage.getItem("canSave"))) {
            this.canSave = JSON.parse(localStorage.getItem("canSave"));
        }
        if (this.page === 'list') {
            if (this.tipType !== "finish") {
                this.isShowFinishTip = true;
            }
            else {
                this.goBack();
            }
        }
        else if (this.page === 'answer') {
            console.log(this.canSave, "this.canSave");
            if (!this.canSave) {
                this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': this.lpmapcId, 'type': 2 }).then();
                this.getExerciseDetailAPI(this.lpmapcId).then(function (result) {
                    _this.exerciseGroup = result;
                    _this.postData = _this.formatPostData(_this.exerciseGroup['questionGroup']);
                    _this.titleText();
                    _this.goBack();
                });
            }
            else {
                this.isShowTip = true;
                this.tipType = 'save';
            }
            this.canSave = false;
        }
    };
    ExerciseWorkComponent.prototype.goBack = function () {
        this.isShowFinishTip = false;
        var learningPathId = null;
        var courseId = null;
        this.route.queryParams.subscribe(function (queryParams) {
            learningPathId = queryParams['learningPathId'];
            courseId = queryParams['courseId'];
        });
        if (this.exerciseType === 3) {
            if (this.isFirstDay) {
                this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { 'firstDay': 1 } });
            }
            else {
                this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { 'isLastDay': 1 } });
            }
        }
        else {
            var learningPathId_1 = null;
            var courseId_1 = null;
            this.route.queryParams.subscribe(function (queryParams) {
                learningPathId_1 = queryParams['learningPathId'];
                courseId_1 = queryParams['courseId'];
            });
            //判断从哪个入口进来
            if (learningPathId_1 && courseId_1) {
                //从训练营进来
                this.router.navigate(['course-new', learningPathId_1, courseId_1]);
            }
            else {
                if (this.exerciseGroup.workSource == 'homework') {
                    var link = [];
                    if (this.projectId) {
                        link = ['learning-project', this.projectId];
                    }
                    else if (this.courseLearningPathMetaId) {
                        link = ['learning-path', this.courseLearningPathMetaId];
                    }
                    this.router.navigate(link).then();
                }
                else {
                    //从作业簿进来
                    this.router.navigate(['exercise-book']).then();
                }
            }
        }
        sessionStorage.removeItem("exerciseScrollTop");
    };
    ExerciseWorkComponent.prototype.unFinishExit = function () {
        if (this.tipType == "showUrl") {
            this.isClick = 1;
            this.downloadPDF(this.downloadUrl);
        }
        else {
            this.goBack();
        }
    };
    ExerciseWorkComponent.prototype.continue = function () {
        var _this = this;
        if (this.tipType == "showUrl") {
            if (window.navigator) {
                window.navigator.clipboard.writeText(window.location.hostname === 'm.transtalent.cn' ? "https://m.transtalent.cn/pc/#/?actualwork=true" : "https://m-uat.transtalent.cn/pc/#/?actualwork=true").then(function (r) {
                    _this.isShowToast = true;
                    _this.toastType = 4;
                    setTimeout(function () {
                        _this.isShowToast = false;
                    }, 1500);
                    console.log("复制成功");
                    _this.isClick = 1;
                });
            }
            this.tipType = "";
            this.isShowFinishTip = false;
        }
        else {
            this.isShowFinishTip = false;
        }
    };
    /**
     * 关闭私密提交弹出层
     */
    ExerciseWorkComponent.prototype.closePopup = function () {
        var _this = this;
        this.openFlag = 1;
        this.tipType = '';
        $('#wx-open-wrap').css('left', '-200%');
        this.isPopupEnter = false;
        setTimeout(function () {
            _this.isShowPopup = false;
        }, 100);
    };
    /**
     * 预览
     * @param event:Object   子组件传递来的预览对象
     */
    ExerciseWorkComponent.prototype.showReview = function (event) {
        this.previewSource = event;
        this.isShowPreview = true;
    };
    /**
     * 关闭预览
     */
    ExerciseWorkComponent.prototype.closePreview = function () {
        this.isShowPreview = false;
    };
    /**
     * 接受子组件传递过来的需要删除文件的下标并删除该文件
     * @param event: Object   子组件传递来的数据
     */
    ExerciseWorkComponent.prototype.deleteUploadFile = function (event) {
        var _this = this;
        this.uploadList = this.uploadList.filter(function (item, i) { return i !== event['index']; });
        this.uploadDisabled = this.uploadList.length === 10;
        var campFileUploadIds = '';
        this.uploadList.forEach(function (item, i) {
            campFileUploadIds = i !== _this.uploadList.length - 1 ? campFileUploadIds + item['id'] + '|' : campFileUploadIds + item['id'];
        });
        this.postData[this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5)]['campFileUploadIds'] = campFileUploadIds;
        // this.formatTableQAData(this.postData);
        var data = {};
        data['campMetaId'] = Number(localStorage.getItem('campId'));
        data['status'] = 10;
        data['openFlag'] = 1;
        data['campExerciseQuestionAnswersVOList'] = this.postData;
        console.log(this.uploadList);
        if (this.isLastDay && this.uploadList.length == 0) {
            data['terminalType'] = 2;
            this.terminalType = 2;
        }
        this.exerciseCommitAPI(data, this.exerciseType).then(function () {
            _this.uploadId = campFileUploadIds;
        });
        localStorage.setItem("uploadList", JSON.stringify(this.uploadList));
        localStorage.setItem("uploadId", this.uploadId);
    };
    /**
     * 文件上传
     * @param files: files 上传的文件
     */
    ExerciseWorkComponent.prototype.fileUpload = function (files) {
        var _this = this;
        if (navigator.onLine) {
            this.fileUploadAPI({ 'files': files['files'], 'id': files['id'] }).then(function (result) {
                _this.uploadId = _this.uploadId === '' ? String(result['id']) : _this.uploadId + '|' + result['id'];
                $(files.el).attr('type', 'file');
            }).then(function () {
                return _this.getUploadFileList({
                    'constituteId': _this.lpmapcId,
                    'questionId': files['id'],
                    'campFileUploadIds': _this.uploadId
                }).then(function (result) {
                    return _this.uploadList = result['newFileList'];
                });
            }).then(function () {
                _this.postData[_this.commonService.getIndexByConditionIdInLists(_this.postData, 'type', 5)]['campFileUploadIds'] = _this.uploadId;
                var data = {};
                data['campMetaId'] = Number(localStorage.getItem('campId'));
                data['status'] = 10;
                data['openFlag'] = 1;
                data['campExerciseQuestionAnswersVOList'] = _this.postData;
                if (_this.isLastDay) {
                    data['terminalType'] = 2;
                }
                _this.exerciseCommitAPI(data, _this.exerciseType).then(function () {
                    _this.uploadId = _this.uploadId;
                });
            }).then(function () {
                _this.oldUploadList = _this.oldUploadList ? _this.oldUploadList : [];
                // let result = this.uploadList.length === this.oldUploadList.length && this.uploadList.every(a => this.oldUploadList.some(b => a === b)) && this.oldUploadList.every(_b => this.uploadList.some(_a => _a === _b));
                // console.log(result);
                _this.uploadDisabled = _this.uploadList.length === 10;
                localStorage.setItem("uploadList", JSON.stringify(_this.uploadList));
                localStorage.setItem("uploadId", _this.uploadId);
            });
        }
        else {
            this.isShowToast = true;
            this.toastType = 2;
            this.errTxt = '保存失败，请检查你的网络设置';
            setTimeout(function () {
                _this.isShowToast = false;
                $('#upload_input').attr('type', 'file');
            }, 2000);
        }
    };
    /**
     * 下载PDF文件
     * @param url: Number PDF's URL
     */
    ExerciseWorkComponent.prototype.downloadPDF = function (url) {
        //先判断是否已经点过
        this.downloadUrl = url;
        if (!this.isClick && this.campId != 2) {
            //没有点过才保存
            this.tipType = "showUrl";
            this.isShowFinishTip = true;
            this.commonService.setOnceIno(this.onceValue).subscribe();
        }
        else {
            this.tipType = "";
            this.isShowFinishTip = false;
            window.open(this.downloadUrl);
        }
        // window.open('ddilearner/v2/camp/applicationPractice/actualOperation/downloadFile/' + id)
    };
    /**
     * 根据试卷ID获取当前试卷所有小题题目
     * @param lpmapcId: Number  试卷Id
     */
    ExerciseWorkComponent.prototype.getExerciseDetailAPI = function (lpmapcId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/applicationPractice/getQuestionGroup/' + lpmapcId,
        }).toPromise();
    };
    /**
     * 提交答案
     * @param postData: JSONObject 作答数据
     * @param exerciseType: Number 作业类型
     */
    ExerciseWorkComponent.prototype.exerciseCommitAPI = function (postData, exerciseType) {
        return this.apiService.ajax({
            'type': 'POST',
            'data': postData,
            'url': exerciseType === 3 && !this.isLastDay ? 'ddilearner/v2/camp/applicationPractice/actualOperation/saveFirstDayTask' : 'ddilearner/v2/camp/applicationPractice/saveAnswers'
        }).toPromise();
    };
    /**
     * 根据第一题选择的选项id获取PDF文件
     * @param postData: JSONObject 选择题选项
     */
    ExerciseWorkComponent.prototype.getExercisePdfAPI = function (postData) {
        return this.apiService.ajax({
            'type': 'POST',
            'data': postData,
            'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/getExercisePdf',
        }).toPromise();
    };
    /**
     * 获取上传文件列表
     * @param postData: JSONObject 查询文件条件对象
     */
    ExerciseWorkComponent.prototype.getUploadFileList = function (postData) {
        return this.apiService.ajax({
            'type': 'POST',
            'data': postData,
            'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/getCampFileList',
        }).toPromise();
    };
    /**
     * 文件上传
     * @param data: Object 上传文件需要的参数
     */
    ExerciseWorkComponent.prototype.fileUploadAPI = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: 'ddilearner/v2/camp/applicationPractice/actualOperation/' + _this.lpmapcId + '/' + data['id'] + '/fileUpload',
                type: 'POST',
                cache: false,
                data: data['files'],
                processData: false,
                contentType: false,
                headers: {
                    'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                    'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
                },
                beforeSend: function (XMLHttpRequest) {
                    _this.isShowLoading = true;
                },
                success: function (res) {
                    resolve(res);
                    setTimeout(function () {
                        _this.isShowLoading = false;
                        $('#upload_input').attr('type', 'file');
                    }, 500);
                },
                error: function (err) {
                    if (err.status === 401 && Number(err.responseJSON.code) === 106) {
                        _this.storeService.notification.notAuthed.next(true);
                    }
                    _this.isShowLoading = false;
                    _this.isShowToast = true;
                    _this.toastType = 2;
                    _this.errTxt = err.status === 413 ? '保存失败，请上传小于10M文件！' : err['responseJSON']['msg'];
                    setTimeout(function () {
                        _this.isShowToast = false;
                        $('#upload_input').attr('type', 'file');
                    }, 2000);
                }
            });
        });
    };
    ExerciseWorkComponent.prototype.getNextBtn = function (event) {
        this.isNextQuestion = event;
    };
    ExerciseWorkComponent.prototype.elementScroll = function (event) {
        var scrollTop = event.target.scrollTop;
        sessionStorage.setItem("exerciseScrollTop", scrollTop);
    };
    /**
     * 删除上传文件
     * @param data: Object 删除文件需要的参数
     */
    ExerciseWorkComponent.prototype.deleteUploadFileAPI = function (data) {
        return this.apiService.ajax({
            'type': 'POST',
            'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/deleteCampUploadFile',
            'data': data
        }).toPromise();
    };
    //获取训练营课程进度(新接口)
    ExerciseWorkComponent.prototype.getCampDayProgress = function (campId, learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/dayProgress?campMetaId=' + campId + '&learningPathMetaId=' + learningPathMetaId
        }).toPromise();
    };
    return ExerciseWorkComponent;
}());
export { ExerciseWorkComponent };



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work.component.ts.pre-build-optimizer.js